import * as Lambda from './LambdaApi';

const getReminders = async (residentId) => {
    try {
        const apiPath = `/residents/${residentId}/reminders`;
        // const reminders = await Lambda.Get(apiPath, {}, 'testLambda');
        const reminders = await Lambda.Get(apiPath, {}, 'lambda');
        return reminders;
    } catch (error) {
        return false;
    }
};

const createReminder = async (residentId, payload) => {
    try {
        const apiPath = `/residents/${residentId}/reminders`;
        // const reminder = await Lambda.Post(apiPath, payload, 'testLambda');
        const reminder = await Lambda.Post(apiPath, payload, 'lambda');
        return reminder;
    } catch (error) {
        return false;
    }
};

// reminder cant be sent in delete request body unless Lambda.Delete is modified
const deleteReminder = async (reminderId) => {
    try {
        const apiPath = `/reminders/${reminderId}`
        // const response = await Lambda.Delete(apiPath, {}, 'testLambda');
        const response = await Lambda.Delete(apiPath, {}, 'lambda');
        return response;
    } catch (error) {
        return false;
    }
}

const editReminder = async (reminderId, reminder) => {
    try {
        const payload = {reminder};
        const apiPath = `/reminders/${reminderId}`
        // const response = await Lambda.Put(apiPath, payload, 'testLambda');
        const response = await Lambda.Put(apiPath, payload, 'lambda');
        return response;
    } catch (error) {
        return false;
    }
}

export {
    getReminders,
    createReminder,
    deleteReminder,
    editReminder
};
